import React, { useEffect } from 'react'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesCaladosActions'
import TablaCamionesCaladosView from '../components/TablaCamionesCaladosView'
import { FORM_PROCESO_CALADO } from '../../../../../../config/forms'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO, INTERVALO } from '../../../../../../config/settings'

function TablaCamionesCalados (props) {
  const { showCircular, actualizarDatosParaMuiTable, filtroInicial } = props

  useEffect(() => {
    actualizarDatosParaMuiTable(filtroInicial)
    const interval = setInterval(() => {
      actualizarDatosParaMuiTable()
      console.log('Ejecutando actualizacion de datos...')
    }, INTERVALO)

    return () => clearInterval(interval)
  }, [actualizarDatosParaMuiTable, filtroInicial])

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      {showCircular
        ? <div style={{ padding: '12% 0', margin: '0 auto' }} >
          <div className='loader' />
          <h4 style={{ margin: '22px ', fontSize: '1.3rem' }}>Actualizando información</h4>
        </div>
        : <TablaCamionesCaladosView />
      }
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    showCircular: state.calado.showCircular
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_PROCESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(TablaCamionesCalados))
